<script>
import options from './SortDropdown.options'
export default options
</script>

<template>
    
    <select v-model="selectedSorting" @change="performSearchWithSort" class="custom-select nti-product-tile-grid__sort">
        <option selected :value="selectedSorting" >{{verifyLabel(options[selectedSorting].label)}}</option>
        <template v-for="(option,index) in options" :key="index">
            <option v-if="selectedSorting !== index" :value="index">{{verifyLabel(option.label)}}</option>
        </template>        
    </select>

</template>

